import { render, staticRenderFns } from "./AccountConsultListItems.vue?vue&type=template&id=45ba2e09&scoped=true"
import script from "./AccountConsultListItems.vue?vue&type=script&lang=js"
export * from "./AccountConsultListItems.vue?vue&type=script&lang=js"
import style0 from "./AccountConsultListItems.vue?vue&type=style&index=0&id=45ba2e09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ba2e09",
  null
  
)

export default component.exports